export const FETCH_LOZIER_STORE_LIST_REQUEST =
  "FETCH_LOZIER_STORE_LIST_REQUEST";
export const FETCH_LOZIER_STORE_LIST_SUCCESS =
  "FETCH_LOZIER_STORE_LIST_SUCCESS";
export const FETCH_LOZIER_STORE_LIST_FAILURE =
  "FETCH_LOZIER_STORE_LIST_FAILURE";

export const ADD_UPDATE_LOZIER_STORE_REQUEST =
  "ADD_UPDATE_LOZIER_STORE_REQUEST";
export const ADD_UPDATE_LOZIER_STORE_SUCCESS =
  "ADD_UPDATE_LOZIER_STORE_SUCCESS";
export const ADD_UPDATE_LOZIER_STORE_FAILURE =
  "ADD_UPDATE_LOZIER_STORE_FAILURE";
